import { Button } from '@insify/design-system/components';
import { useEffect, useState } from 'react';

import { MarkdownPresentation } from '../../../features/assistant/components/Presentation/Presentation';
import { useAuthStore } from '../../../stores/authStore';

import type { PresentationSlide } from '../../../api/getChat';

const SlideDesignerPage: React.FC = () => {
  const setIsAuthComplete = useAuthStore((state) => state.setIsAuthComplete);

  const [markdown, setMarkdown] = useState('');
  const [slides, setSlides] = useState<PresentationSlide[]>([]);
  useEffect(() => {
    setIsAuthComplete(true);
  }, []);

  useEffect(() => {
    const slides: PresentationSlide[] = markdown.split('\n---\n').map((s) => {
      const elements = s.split(/### Narration|### Questions|### Theme/g);
      const content = elements.at(0)?.trim() || '';
      const narration = elements.at(1)?.trim() || '';
      const questions =
        elements
          .at(2)
          ?.split('- ')
          .map((q) => q.trim()) || [];
      const theme = (elements.at(3)?.trim() || 'white') as PresentationSlide['theme'];
      return { content, narration, questions, theme };
    });

    setSlides(slides);
  }, [markdown]);

  return (
    <div style={{ margin: 20 }}>
      <div style={{ display: 'flex', gap: 50, marginBottom: 20 }}>
        <textarea
          rows={40}
          style={{ width: '100%' }}
          value={markdown}
          onChange={(el) => {
            console.log(el);
            el.target.value && setMarkdown(el.target.value);
          }}
        />
        <MarkdownPresentation slides={slides} variables={{}} />
      </div>
      <Button
        kind='primary'
        type='button'
        trackingId='save-presentation'
        onClick={() => {
          const blob = new Blob([markdown], { type: 'text/markdown' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'presentation.md';
          link.click();
          URL.revokeObjectURL(url);
        }}
        style={{ padding: '8px 16px', cursor: 'pointer' }}
      >
        Save to File
      </Button>
    </div>
  );
};

export { SlideDesignerPage };
